import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const industryOverviewSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="branchen"
    class=${editorNodeClass(editor, 'section.industryOverview', 'vp-section vp-industry-section')}
    style=${editorNodeStyle(editor, 'section.industryOverview')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.industryOverview', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.industryOverview', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.industryOverview.eyebrow,
        title: content.industryOverview.title,
        highlight: content.industryOverview.titleHighlight,
        text: content.industryOverview.text,
        align: 'center',
        editor,
        elementPrefix: 'industryOverview',
      })}
      <div
        class=${editorNodeClass(editor, 'industryOverview.items', 'vp-industry-grid')}
        style=${editorNodeStyle(editor, 'industryOverview.items')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'industryOverview.items', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'industryOverview.items', event)}
      >
        ${content.industryOverview.items.map((item, index) => {
          const cardId = `industryOverview.item.${index}`;
          return html`
            <a
              class=${editorNodeClass(editor, cardId, 'vp-industry-card reveal-card')}
              style=${editorNodeStyle(editor, cardId)}
              href=${item.href}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, cardId, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, cardId, event)}
            >
              <span
                class=${editorNodeClass(editor, `${cardId}.icon`, item.iconClass)}
                style=${editorNodeStyle(editor, `${cardId}.icon`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${cardId}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `${cardId}.icon`, event)}
              ></span>
              ${editorSemanticText({ editor, elementId: `${cardId}.title`, fallbackTag: 'h3', content: item.title })}
              ${editorSemanticText({ editor, elementId: `${cardId}.text`, fallbackTag: 'p', content: item.text })}
              <strong
                class=${editorNodeClass(editor, `${cardId}.linkLabel`, 'vp-industry-link')}
                style=${editorNodeStyle(editor, `${cardId}.linkLabel`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${cardId}.linkLabel`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `${cardId}.linkLabel`, event)}
              >
                ${item.linkLabel}
                <span class="icon-[material-symbols--arrow-forward]"></span>
              </strong>
            </a>
          `;
        })}
      </div>
    </div>
  </section>
`;
